import * as React from 'react'
// Import from a CSS file in your src

const MHALink = (props) => {
  return (
    <a href={ props.whereTo } className={["btn btn-sm " + props.btnClass]} rel={props.rel} target={props.target}><span className={props.linkIcon}></span> {props.linkText}</a>
  )
}

export default MHALink